'use es6';

import { connect } from 'react-redux';
import FormFieldInput from './FormFieldInput';
import { hasProgressiveProfillingAccess } from 'FormsUI/selectors/Scope';
import { getPropertyAnnotations } from 'FormsUI/selectors/PropertyAnnotations';
const mapStateToProps = state => ({
  hasProgressiveProfilling: hasProgressiveProfillingAccess(state),
  hasPropertyAnnotationsHintsEnabled: getPropertyAnnotations(state)
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(FormFieldInput);